import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener} 	from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { CommonAdminService } from '@tanzeel/shared';
import { StudentBlockUIService } from '@student/core/blockui/student-blockui.service';
import { StudentMessagingService } from '@student/core/messaging/student-messaging.service';
@Component({
        standalone: false,
  selector: 'student-additionalinfo-popup',
  templateUrl: "./student.additionalinfo.popup.html",
  styles : [
	`
		.donationdrive-modal-parent {
			position: absolute;
			left: 50%;
			z-index: 100;
			min-width : 50%;
			max-width : 90%;
		}
		.ui_modal.donationdrive-modal {
			position: relative;
			z-index: 101;
			max-width: 90%;
			left: -50%;
		}
		@media (max-width:767px) {
			.ui_modal.donationdrive-modal {
				max-width: 94%;
				margin-left: 3%;
			}
			.donationdrive-modal-parent {
				min-width : 85%;
			}
			.donationdrive-modal-parent .ui_modal .ui_modal_btns .ui_btn.ui_btn_primary {
				margin-top : 10px;
			}
		}
	`

  ]
})
export class UiKitAdditionalInfoModalComp implements OnInit , AfterViewInit  {

			
	@Output() close:any = new EventEmitter<any>();
	@Input() forStudent:any = 0;
	

	initialized:boolean = false;


	showError:boolean = false;

	studentObject:any = null;
	studentinfoForm:any = null;
	studentAddlInfo:any = null;
    constructor(private _el: ElementRef , private _cas:CommonAdminService , private mms:StudentMessagingService , private bks:StudentBlockUIService, private fb:FormBuilder ){
    }

    ngOnInit(){
		this.initialized=true;
		//console.info( " ************************************************** ");
		this.studentObject = this._cas.getLoggedInStudent( this.forStudent );
		this.studentinfoForm = this.fb.group({
			eduBackground 			 		: [ '' ],

			learningGoalsObj 	 			: [ '' ],
			pLearningExp 	 					: [ '',  ],
			pSuccessMetrics 	 			: [ '' ],
			pLearningHab 	 					: [ ''],
			suggestions 	 					: [ '' ],
		});
    }
		
	ngAfterViewInit() {
		this._cas.getStudentAdditionalInfo( this.studentObject.id , this , this.viewAddlInfoSuccess , this.viewAddlInfoFailure );
	}
	
	viewAddlInfoSuccess( data:any ){
		this.initializeForm();
	}

	viewAddlInfoFailure( data:any ){
	
	}

	initializeForm(){
		this.studentinfoForm.reset();
		if( this.studentAddlInfo != null && this.studentAddlInfo.educationalBcg && this.studentAddlInfo.educationalBcg!=null ){
			this.studentinfoForm.get('eduBackground').patchValue(this.studentAddlInfo.educationalBcg);
		}
		if( this.studentAddlInfo != null && this.studentAddlInfo.ethinicBcg && this.studentAddlInfo.ethinicBcg!=null ){
			this.studentinfoForm.get('ethnicBackground').patchValue(this.studentAddlInfo.ethinicBcg );
		}
		if( this.studentAddlInfo != null && this.studentAddlInfo.goalsObjectives && this.studentAddlInfo.goalsObjectives!=null ){
			this.studentinfoForm.get('learningGoalsObj').patchValue(this.studentAddlInfo.goalsObjectives );
		}

		
		if( this.studentAddlInfo != null && this.studentAddlInfo.persSuccessMetrics && this.studentAddlInfo.persSuccessMetrics!=null ){
			this.studentinfoForm.get('pSuccessMetrics').patchValue(this.studentAddlInfo.persSuccessMetrics );
		}

		if( this.studentAddlInfo != null && this.studentAddlInfo.pastLearnExpr && this.studentAddlInfo.pastLearnExpr!=null ){
			this.studentinfoForm.get('pLearningExp').patchValue(this.studentAddlInfo.pastLearnExpr );
		}

		if( this.studentAddlInfo != null && this.studentAddlInfo.persLearnHabits && this.studentAddlInfo.persLearnHabits!=null ){
			this.studentinfoForm.get('pLearningHab').patchValue(this.studentAddlInfo.persLearnHabits );
		}

		if( this.studentAddlInfo != null && this.studentAddlInfo.suggestTeacher && this.studentAddlInfo.suggestTeacher!=null ){
			this.studentinfoForm.get('suggestions').patchValue(this.studentAddlInfo.suggestTeacher );
		}
	}

	action( selval:string ){
		
	}

	closeIcon(){
		this.close.emit();
	}

	eduBackgroundFldInFocus:boolean = false;
	ethnicBackgroundFldInFocus:boolean = false;
	learningGoalsObjFldInFocus:boolean = false;
	pLearningExpFldInFocus:boolean = false;
	pSuccessMetricsFldInFocus:boolean = false;
	pLearningHabFldInFocus:boolean = false;
	suggestionsFldInFocus:boolean = false;

	eduBackgroundFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('eduBackground').value != null && this.studentinfoForm.get('eduBackground').value != '' ) );
	}

	ethnicBackgroundFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('ethnicBackground').value != null && this.studentinfoForm.get('ethnicBackground').value != '' ) );
	}

	learningGoalsObjFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('learningGoalsObj').value != null && this.studentinfoForm.get('learningGoalsObj').value != '' ) );
	}

	pLearningExpFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('pLearningExp').value != null && this.studentinfoForm.get('pLearningExp').value != '' ) );
	}

	pSuccessMetricsFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('pSuccessMetrics').value != null && this.studentinfoForm.get('pSuccessMetrics').value != '' ) );
	}

	pLearningHabFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('pLearningHab').value != null && this.studentinfoForm.get('pLearningHab').value != '' ) );
	}

	suggestionsFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('suggestions').value != null && this.studentinfoForm.get('suggestions').value != '' ) );
	}

	submit(  ){
		if( this.studentAddlInfo == null ){
			this.studentAddlInfo = {};
		}
		var studentformvalue = this.studentinfoForm.value;

		this.studentAddlInfo.educationalBcg = studentformvalue.eduBackground;
		this.studentAddlInfo.ethinicBcg = studentformvalue.ethnicBackground;
		this.studentAddlInfo.goalsObjectives = studentformvalue.learningGoalsObj;
		this.studentAddlInfo.pastLearnExpr = studentformvalue.pLearningExp;
		this.studentAddlInfo.persLearnHabits = studentformvalue.pLearningHab;
		this.studentAddlInfo.suggestTeacher = studentformvalue.suggestions;
		this.studentAddlInfo.persSuccessMetrics = studentformvalue.pSuccessMetrics;
		this.bks.show();
		var student = this.studentObject;
		student.additionalInfo = this.studentAddlInfo;
		this._cas.saveStudentAdditionalInfo( student , true, this , this.updateStudentSuccess , this.updateStudentFailure );
	}

	updateStudentSuccess( data:any ){
		try {
			if(data.json().details)
				this.mms.show(" Save student Additional Info "+ data.json().details , true);
			else 
			this.mms.show(" Save student additional info success " , true);
		} catch (error) {
			this.mms.show(" Save student additional info success " , true);
		
		}
		this.bks.hide();
		this.closeIcon();
	}

	updateStudentFailure( data:any ){
		this.bks.hide();
		try{
			this.mms.show(data.json().details , false);
		  }catch(e){
			  //console.info(data);
			  try{
				this.mms.show("Additional Info Updation Failed!"  , false);
			  }catch(e){
				  this.mms.show( "Failed!!"  , false);
			  }
		  }	
	}

	auto_grow( event:any ){
		
		var ele = event.target;
		ele.style.height = "5px";
		ele.style.height = (ele.scrollHeight)+"px";
	}

	getStudentFullName(){
		return this.studentObject.fullName;		
	}
}